<template>
  <div>
    <Breadcrumbs title="Add Batch" main="Database"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card" v-if="!products">
            <div class="card-header"><h5>Select file</h5></div>

            <form @submit.prevent="prepareProductBatch">
              <div class="card-body">
                <div class="form-group">
                  <label>File</label>
                  <input type="file" class="form-control-file" @change="handleFileUpload( $event )">
                </div>
              </div>

              <div class="card-footer">
                <router-link
                    to="/research/database"
                    custom
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                  <a :href="href" @click="navigate" class="btn btn-info mr-2">Cancel</a>
                </router-link>
                <button type="submit" :disabled="fileUpload" class="btn btn-primary pull-right">Prepare</button>
              </div>
            </form>
          </div>


          <div class="card" v-if="products">
            <div class="card-header"><h5>Select product for creating</h5></div>

            <div class="card-body">

              <div class="table mb-4">
                <table role="table" aria-busy="false" aria-colcount="4"
                       class="table b-table table-striped table-hover">
                  <thead role="rowgroup" class="">
                  <tr role="row" class="">
                    <th></th>
                    <th>Date</th>
                    <th>Part Number</th>
                    <th>Brand</th>
                    <th>Name</th>
                    <th>Price</th>
                    <th>Competitor</th>
                  </tr>
                  </thead>
                  <tbody role="rowgroup">
                  <tr role="row" v-for="(product, index) in products" :key="index"
                      :class="{ 'bg-danger': !product.part_exists, 'bg-primary': product.is_duplicate }">
                    <td>
                      <div class="checkbox checkbox-dark">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input"
                                 :disabled="!product.part_exists"
                                 v-model="checkedRows[index]"
                          >
                        </div>
                      </div>
                    </td>
                    <td>{{ product.date }}</td>
                    <td>{{ product.part_number }}</td>
                    <td>{{ product.brand.toUpperCase() }}</td>
                    <td>{{ product.name || '-' }}</td>
                    <td>${{ product.price }}</td>
                    <td>{{ product.competitor }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <router-link
                  to="/research/database"
                  custom
                  v-slot="{ href, route, navigate, isActive, isExactActive }"
              >
                <a :href="href" @click="navigate" class="btn btn-info mr-2">Cancel</a>
              </router-link>
              <button type="button" class="btn btn-primary pull-right" @click="createProductBatch">Create</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.checkbox input[type="checkbox"] {
  opacity: 1 !important;
}
</style>

<script>
import {competitorProduct} from "../../../_services";

export default {
  data: function () {
    return {
      file: null,
      products: null,
      fileUpload: false,
      checkedRows: []
    }
  },
  methods: {
    createProductBatch() {
      let selectedProducts = [];

      this.checkedRows.forEach((checked, index) => {
        if (checked) {
          selectedProducts.push(this.products[index]);
        }
      });

      competitorProduct.createCompetitorProductBatch(selectedProducts)
          .then(
              async () => {
                const {dispatch} = this.$store;
                dispatch('alert/success', 'Product batch success added', {root: true});

                this.$router.push({
                  path: '/research/database'
                });
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    prepareProductBatch() {
      this.fileUpload = true;

      competitorProduct.prepareCompetitorProductBatch(this.file)
          .then(
              async products => {
                this.products = products;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
                this.fileUpload = false;
              }
          );
    }
  }
}
</script>
